import { activeFilters } from './activeFilters';

if (window.theme.template === 'collection' || window.theme.template === 'search') {
  const urlParamsNew = addAvailabilityFilter(window.location.search.slice(1));
  renderContent(urlParamsNew);
}

function fetchContent(url, e) {
  const loading = document.querySelector('[data-loading]');
  if (loading) loading.classList.remove('hidden');
  fetch(url)
    .then((response) => response.text())
    .then((responseText) => {
      const parser = new DOMParser();
      const html = parser.parseFromString(responseText, 'text/html');

      console.log("html", html.querySelector('#sizeFilters'))
      replaceContent(html, e);
      if (loading) loading.classList.add('hidden');
    });
}

function replaceContent(html, e) {

  if (!html) return;
  const filterEls = document.querySelectorAll('#FilteringAndSorting .filter');
  replaceContentByQuery('#ProductGridContainer:not(.relewise)', html);
  replaceContentByid('ActiveFiltersContainer', html);
  filterEls?.forEach((filterGroup) => {
    const groupID = filterGroup.querySelector('.mobile-active-filters')?.id;
    if (groupID) replaceContentByid(groupID, html);
  });
  // replaceContentByid("ProductCountContainer", html);
  replaceContentByid('ProductCountMobileContainer', html);
  replaceContentByid('ProductCountDrawerContainer', html);
  replaceContentByid('close-filter-mobile', html);
  /* replaceContentByid('size-filters__group', html); */
  const sizeFilterGroups = document.querySelectorAll('.size-filters__group');
  if (sizeFilterGroups) {
    document.querySelectorAll('.size-filters__group').forEach(el => {
      const groupId = el?.id;
      if (groupId) replaceContentByid(groupId, html);
    })
  }


  filterEls?.forEach((filterGroup) => {
    filterGroup.querySelectorAll('.facets__list > .facet').forEach((checkBoxGroup) => {
      const checkID = checkBoxGroup.id;
      if (checkID) replaceContentByid(checkID, html);
    });

    const filterActiveCountWrapperID = filterGroup.querySelector('.filter__label-reactive')?.id;
    if (filterActiveCountWrapperID) replaceContentByid(filterActiveCountWrapperID, html);
  });
  // replaceContentByid("Sorting", html);
  replaceFilterElements(html, e);

  const event = new CustomEvent('product-grid:replaced', {});
  document.dispatchEvent(event);
}

function replaceContentByid(targetId, html) {
  const sourceEl = html.getElementById(targetId);
  const destinationEl = document.getElementById(targetId);

  if (destinationEl && sourceEl) destinationEl.innerHTML = sourceEl.innerHTML;
}

function replaceContentByQuery(targetQuery, html) {
  const sourceEl = html.querySelector(targetQuery);
  const destinationEl = document.querySelector(targetQuery);

  if (destinationEl && sourceEl) destinationEl.innerHTML = sourceEl.innerHTML;
}

function resetActiveFacets(target) {
  if (!target) return;
  const targetElements = target.querySelectorAll('.facets__list li input');

  targetElements.forEach((element) => {
    element.checked = false;
  });
}

function replaceFilterElements(html, e) {
  const filterElements = html.querySelectorAll('#FilteringAndSorting .js-filter, #FilteringAndSortingMobile .js-filter');

  const matchesIndex = (element) => {
    const jsFilter = e ? e.target.closest('.js-filter') : undefined;
    return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
  };

  const otherFacetsToRender = Array.from(filterElements).filter((element) => !matchesIndex(element));
  const facetToRender = Array.from(filterElements).find(matchesIndex);

  otherFacetsToRender.forEach((element) => {
    document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
  });

  if (facetToRender) replaceCurrentFacet(facetToRender, e.target.closest('.js-filter'));

  activeFilters();
}

function replaceCurrentFacet(source, target) {
  const targetElement = target.querySelector('.facets__header');
  const sourceElement = source.querySelector('.facets__header');

  if (sourceElement && targetElement) {
    targetElement.outerHTML = sourceElement.outerHTML;
  }
}

function getSections() {
  return [
    {
      sectionId: document.getElementById('ProductGridContainer')?.dataset.id,
    },
  ];
}

function renderContent(urlParams, e) {
  const sections = getSections();
  const urlParamsNew = addAvailabilityFilter(urlParams);

  updateURLHash(urlParamsNew);

  sections.forEach((section) => {
    const url = `${window.location.pathname}?section_id=${section.sectionId}&${urlParamsNew}`;

    fetchContent(url, e);
  });
}

function updateURLHash(urlParams) {
  if (document.querySelector('.relewise-search')) return;
  const queryString = urlParams ? `?${urlParams}` : '';
  history.pushState({ urlParams }, '', `${window.location.pathname}${queryString}`);
}

function addAvailabilityFilter(urlParams) {
  if (document.querySelector('.relewise-search')) return urlParams;

  const availabilityParam = 'filter.v.availability=1';
  if (urlParams) {
    const notAvailabilityParam = 'filter.v.availability=0';
    const urlParamsArray = urlParams.split('&');
    const urlParamsSet = new Set(urlParamsArray);
    urlParamsSet.delete(notAvailabilityParam);
    urlParamsSet.add(availabilityParam);
    return Array.from(urlParamsSet).join('&');
  }
}

export { renderContent, resetActiveFacets };
